import React from "react";
import AttendanceMonthlyReportList from "./AttendanceMonthlyReportList";

function InternMonthlyAttendanceReportList() {
  return (
    <AttendanceMonthlyReportList
      defaultPersonTypeId="2"
      heading="Intern Monthly Attendance Report"
      routePath="/attendance/monthly-report/interns"
    />
  );
}

export default InternMonthlyAttendanceReportList;

